import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { STORAGE_KEYS } from '~/storage-keys';

interface CompanyState {
  /** Empresa em que o usuário está operando. `null` = a primeira da lista. */
  selectedCompanyId: number | null;
  select(companyId: number): void;
  clear(): void;
}

/**
 * Guarda só o id: a lista de empresas (com papel e níveis) vive na sessão e vem de
 * `/auth/me`. Persistido no `localStorage`, portanto por origem, e apagado no logout
 * junto com o resto da sessão (`clearLocalData`).
 */
export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      selectedCompanyId: null,
      select: (companyId) => set(() => ({ selectedCompanyId: companyId })),
      clear: () => set(() => ({ selectedCompanyId: null })),
    }),
    {
      name: STORAGE_KEYS.selectedCompany,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ selectedCompanyId: state.selectedCompanyId }),
    },
  ),
);
